import { styled, Box, Card, CardContent, Tab } from '@mui/material';
import { TabPanel } from '@mui/lab';
import { alpha } from '@mui/material/styles';

export const VISIBILITY_ITEMS = 3.5;
export const HEIGHT_ROUTE_CARD = 75;

export const AddOrdersToRouteMenuContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(1.5),
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  minWidth: 400,
}));

export const AddOrdersToRouteMenuTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.common.white,
  flex: 1,
  borderRight: `1px solid ${theme.palette.common.white}`,
}));

export const AddOrdersToRouteMenuTabPanel = styled(TabPanel)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1.5, 2),
}));

export const AddOrdersToRouteMenuContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  gap: theme.spacing(2),
}));

export const AddOrdersToRouteMenuContentList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  gap: theme.spacing(1),
  overflowY: 'auto',
  height: '100%',
  maxHeight: (HEIGHT_ROUTE_CARD + 8) * VISIBILITY_ITEMS,
  minHeight: HEIGHT_ROUTE_CARD,
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',

  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const AddOrdersToRouteMenuCardContainer = styled(Card)(({ theme }) => ({
  minHeight: HEIGHT_ROUTE_CARD,
  transition: theme.transitions.create(['background-color', 'border-color'], {
    duration: theme.transitions.duration.short,
  }),

  '&:hover': {
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: alpha(
      theme.palette.primary.main,
      theme.palette.action.focusOpacity,
    ),
  },
}));

export const AddOrdersToRouteMenuCardContent = styled(CardContent)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 2),

    '&:last-child': {
      paddingBottom: theme.spacing(0.5),
    },
  }),
);

export const AddOrdersToRouteMenuCardVehicleInfoBox = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(0.5),
    alignItems: 'center',
  }),
);

export const AddOrdersToRouteMenuCardVehicleInfoBoxTitleContainer = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    flex: 1,
    fontWeight: theme.typography.fontWeightBold,
  }),
);

export const AddOrdersToRouteMenuCardRouteInfoBox = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(0.5),
    flexDirection: 'column',
  }),
);

export const AddOrdersToRouteMenuCardRouteInfoBoxRow = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(1),
  }),
);
